import faqToggle        from './modules/faq';
import footer_bg        from './modules/footerBg';
import searchToogle     from './modules/searchMob';
import mobileMenu       from './modules/mobileMenu';
import asideToggler     from './modules/asideToggler';
//import freeGameStart    from './modules/freeGameStart';
import loadMoreOffers   from './modules/loadMoreOffers';
//import gameInfoTogggler from './modules/gameInfoTogggler';
import popup            from './modules/popup';



document.addEventListener("DOMContentLoaded", () => {
    
    'use strict';

    popup();
    faqToggle();
    footer_bg();
    mobileMenu();
    searchToogle();
    asideToggler();
    //freeGameStart();
    loadMoreOffers()
    //gameInfoTogggler();

});